import { useEffect, useMemo, useRef } from 'react';
import { isEmptyData } from '../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { postLoyaltyProfile } from '../../store/reducers/loyalty';
import { USER_STATUS } from '../../utils/constants';

const useLoyalty = () => {
	const dispatch = useDispatch();
	const user = useSelector((store) => store?.user);
	const isLogin = !isEmptyData(user?.token) && user?.status === USER_STATUS.ACTIVE;
	const { loyalty, tokenProfile, isLoadingLoyalty, tier, config, vouchers: loyaltyVouchers, hidden } = useSelector((store) => store?.loyalty);

  const hasFetched = useRef(false);

	const handlePostLoyaltyProfile = async () => {
		try {
			dispatch(postLoyaltyProfile());
      console.count('handlePostLoyaltyProfile');
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const isProfileCompleted = useMemo(() => {
		return isLogin && !isEmptyData(user?.firstName) && !isEmptyData(user?.primary_phone) && !isEmptyData(user?.email) && !isEmptyData(user?.gender) && !isEmptyData(user?.birthDate);
	}, [isLogin, user?.firstName, user?.primary_phone, user?.email, user?.gender, user?.birthDate]);

  useEffect(() => {
    if (!isProfileCompleted || hasFetched.current) return;
  
    hasFetched.current = true;
    handlePostLoyaltyProfile();
  }, [isProfileCompleted]);

	return {
		loyalty,
		isLoading: isLoadingLoyalty,
		tier,
		config,
		loyaltyVouchers,
		isProfileCompleted,
		tokenProfile,
    hidden,
	};
};

export default useLoyalty;
